// extracted by mini-css-extract-plugin
export default {"body":"main_body__CRWFk","wrapper":"main_wrapper__O4BWK","column":"main_column__fl+cf"};